import './style.scss'; 
 
import React, { FC } from 'react';
import { ReactComponent as IconArrowRight } from "assets/img/icons/icon_arrow-Right.svg";
import { ReactComponent as IconCheck } from "assets/img/icons/icon_Check.svg";
import { ReactComponent as IconInfo } from "assets/img/icons/icon_User.svg";
import { ReactComponent as IconStatus } from "assets/img/icons/icon_status-Checked.svg";
import { ReactComponent as IconPayment } from "assets/img/icons/payment/payStep.svg";


interface StatusSouscriptionProps {
    steps: any;
    handleUpdateStep: (status: number) => void;
}
 
const StatusSouscription: FC<StatusSouscriptionProps> = ({
    steps,
}) => {


    const STEP_1 = 35, STEP_2 = 70, STEP_3 = 100;

    const getPercents = () => {
        switch (steps) {
            case 0:
                return STEP_1;
            case 1:
                return STEP_1;
            case 2:
                return STEP_2;
            case 3:
                return STEP_3;
            default:
                return 0;
        }
    };
  return (
      <div className="StatusAccompagnement">
          <div
              className={`StatusAccompagnement__step ${getPercents() >= STEP_1 ? 'StatusAccompagnement__step__success' : 'StatusAccompagnement__step__disabled'}`}>
              <div>
                  <IconInfo
                      fill="#12BC61"
                      width={16}
                  />
              </div>
              <span>Info<span>rmations personnelles</span></span>
              {getPercents() >= STEP_1 && (
                  <IconCheck
                      fill="#12BC61"
                      width={14}
                  />
              )}
          </div>
          <IconArrowRight
              fill={`${getPercents() >= STEP_2 ? '#12BC61' : '#A3BBDC'}`}
              width={20}
          />
          <div
              className={`StatusAccompagnement__step ${getPercents() >= STEP_2 ? "StatusAccompagnement__step__success" : "StatusAccompagnement__step__disabled"}`}>
              <div>
                  <IconPayment
                      fill={`${getPercents() >= STEP_2 ? '#12BC61' : '#A3BBDC'}`}
                      width={16}
                  />
              </div>
              <span>Paiement <span>de l’offre</span></span>
              {getPercents() > STEP_2 ? (
                  <IconCheck
                      fill="#12BC61"
                      width={14}
                  />
              ) : (<div>...</div>)}
          </div>
          <IconArrowRight
              fill={`${getPercents() >= STEP_3 ? "#12BC61" : "#A3BBDC"}`}
              width={20}
          />
          <div
              className={`StatusAccompagnement__step ${getPercents() >= STEP_3 ? 'StatusAccompagnement__step__success' : 'StatusAccompagnement__step__disabled'}`}>
              <div>
                  <IconStatus
                      fill={`${getPercents() >= STEP_3 ? "#12BC61" : "#A3BBDC"}`}
                      width={16}
                  />
              </div>
              <span>Statut <span>du paiement</span></span>
              {getPercents() > STEP_3 ? (
                  <IconCheck
                      fill="#12BC61"
                      width={14}
                  />
              ) : (<div>...</div>)}
          </div>
      </div>
  );
}

export default StatusSouscription; 
